export class EntFarmOwner {
  id: number = 0; 
  pin: string = '';
  secondName: string = '';
  name: string = '';
  patronymic: string = '';
  contacts: string = '';
}
